export default "__VITE_ASSET__5386ed9f__"